export default __webpack_public_path__ + "static/media/prize-1-bm.dca4b131.webp";